import { Check } from 'lucide-react';

export default function Pricing() {
  const plans = [
    {
      name: 'Basic',
      price: 0.99,
      period: 'year',
      description: 'Perfect for personal projects',
      features: [
        '1 Domain Registration',
        'Free WHOIS Privacy',
        'Basic DNS Management*',
        'Basic Support',
      ],
      popular: false,
    },
    {
      name: 'Premium',
      price: 4.99,
      period: 'year',
      description: 'Ideal for growing businesses',
      features: [
        '5 Domain Registrations',
        'Free WHOIS Privacy',
        'Advanced DNS Management**',
        'Email Forwarding',
        'Priority Support',
      ],
      popular: true,
    },
    {
      name: 'Business',
      price: 29.99,
      period: 'year',
      description: 'For established enterprises',
      features: [
        '50 Domain Registrations',
        'Free WHOIS Privacy',
        'Premium DNS Management***',
        'Email Forwarding',
        '24/7 Dedicated Support',
        
      ],
      popular: false,
    },
  ];

  return (
    <section id="pricing" className="py-20 px-4 sm:px-6 lg:px-8 bg-section-pricing">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-3xl sm:text-4xl font-bold text-theme-primary mb-4">
            Simple, Transparent Pricing
          </h2>
          <p className="text-xl text-theme-secondary max-w-3xl mx-auto">
            Choose the plan that fits your needs. No hidden fees, ever.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {plans.map((plan, index) => (
            <div
              key={index}
              className={`relative p-8 rounded-2xl border-2 glass-card ${
                plan.popular
                  ? 'border-blue-500/50'
                  : 'border-white/10'
              }`}
            >
              {plan.popular && (
                <div className="absolute -top-4 left-1/2 transform -translate-x-1/2">
                  <span className="glass-button text-white px-4 py-1 rounded-full text-sm font-semibold">
                    Most Popular
                  </span>
                </div>
              )}
              
              <div className="text-center mb-8">
                <h3 className="text-2xl font-bold text-theme-primary mb-2">
                  {plan.name}
                </h3>
                <p className="text-theme-secondary mb-4">{plan.description}</p>
                <div className="flex items-baseline justify-center">
                  <span className="text-4xl font-bold text-theme-primary">
                    ${plan.price}
                  </span>
                  <span className="text-theme-secondary ml-2">/{plan.period}</span>
                </div>
              </div>

              <ul className="space-y-4 mb-8">
                {plan.features.map((feature, featureIndex) => (
                  <li key={featureIndex} className="flex items-start">
                    <Check className="h-5 w-5 text-green-500 mr-3 shrink-0 mt-0.5" />
                    <span className="text-theme-secondary">{feature}</span>
                  </li>
                ))}
              </ul>

              <a
                href="https://domains0.com"
                target="_blank"
                rel="noopener noreferrer"
                className={`w-full py-3 rounded-lg font-semibold transition-colors block text-center ${
                  plan.popular
                    ? 'glass-button text-white'
                    : 'glass-card text-theme-primary hover:bg-white/15'
                }`}
              >
                Get Started
              </a>
            </div>
          ))}
        </div>

        <div className="mt-12 text-left text-sm text-gray-500">
          
          <p>* Only A/CNAME records</p>
          <p>** A/CNAME/MX/TXT records</p>
          <p>*** All DNS records with external NS records also</p>
        </div>
      </div>
    </section>
  );
}
